<template>
    <div class="childtrackingsystem-generalform">
        <div class="row py-3 bg-white">
            <div class="col-12 d-flex justify-content-between align-items-center">
                <div>
                    <span class="fw-bold">{{ form.title }} </span> van kind
                    <span class="fw-bold">"{{ child.childName }}" </span>({{ child.childAge }} maanden)
                </div>
                <button
                    class="btn btn-outline-secondary ms-2"
                    @click="goBack()"
                >Terug
                </button>
            </div>
        </div>
        <div
            class="row pb-3 bg-white"
            v-for="(category, cIdx) in formContent"
            v-bind:key="cIdx"
        >
            <div class="col-12">
                <div class="row pb-2">
                    <div class="col-12 fw-bold">{{ category.name }}</div>
                </div>
                <div
                    class="row pb-1"
                    v-for="(question, qIdx) in category.questions"
                    v-bind:key="qIdx"
                >
                    <label class="col-10 col-lg-6 col-form-label">{{question.question}}</label>
                    <div
                        class="col-12 col-lg-6 mt-2"
                        v-if="question.inputType === 'radio'"
                    >
                        <div
                            class="form-check form-check-inline"
                            v-for="(answer, aIdx) in question.answers"
                            v-bind:key="aIdx"
                        >
                            <input
                                class="form-check-input"
                                type="radio"
                                :id="'checkedAnswer-' + question.id + '-' + answer.id"
                                :name="'checkedAnswer[' + question.id +']'"
                                v-model="checkedAnswer[question.id]"
                                :checked="answer.id === question.selectedAnswer"
                                :value="answer.id"
                            />
                            <label
                                class="form-check-label"
                                :for="'checkedAnswer-' + question.id + '-' + answer.id"
                            >
                                {{answer.answer}}
                            </label>
                        </div>
                        <div class="mt-2">
                            <label
                                class="form-label"
                                for="radioExplanation"
                            >Toelichting</label>
                            <textarea
                                class="form-control"
                                id="radioExplanation"
                                rows="2"
                                v-model="answerNote[question.id]"
                            ></textarea>
                        </div>
                    </div>
                    <div
                        class="col-12 col-lg-6"
                        v-if="question.inputType === 'text'"
                    >
                        <textarea
                            class="form-control"
                            rows="2"
                            v-model="answerNote[question.id]"
                        ></textarea>
                    </div>
                    <div
                        class="col-2 col-lg-6 pt-2"
                        v-if="question.inputType === 'checkbox'"
                    >
                        <div class="form-check">
                            <input
                                v-if="question.selectedAnswer === '1'"
                                class="form-check-input"
                                type="checkbox"
                                :name="'checkedAnswer[' + question.id +']'"
                                v-model="checkedAnswer[question.id]"
                                checked
                            />
                            <input
                                v-else
                                class="form-check-input"
                                type="checkbox"
                                :name="'checkedAnswer[' + question.id +']'"
                                v-model="checkedAnswer[question.id]"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row py-3 justify-content-end bg-white">
            <div class="col-auto">
                <button
                    class="btn btn-outline-primary"
                    @click="saveForm();"
                >Opslaan</button>
                <button
                    v-if="idGeneralForm > 0"
                    type="submit"
                    class="btn btn-outline-danger ms-2"
                    @click="printForm();"
                >PDF</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "childtrackingsystem-generalform",
  components: {},
  props: ['idChild', 'idForm', 'idGeneralForm'],
  data() {
    return {
      child: [],
      form: [],
      formContent: [],
      answerNote: [],
      checkedAnswer: []
    }
  },
  computed: {
    deviceToken() {
      return this.$store.getters.deviceToken
    },
    session() {
      return this.$store.getters.session
    },
  },
  created() {
    window.novict = {
      device: {
        device_token: this.deviceToken
      },
      session: {
        session_token: this.session.session_token
      }
    }
    this.getResults()
  },
  methods: {
    getResults() {
      this.isLoading = true
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/getGeneralForm', {
        idChild: this.idChild,
        idForm: this.idForm,
        idGeneralForm: this.idGeneralForm
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response) {
          this.child = response.child
          this.form = response.form
          this.formContent = response.formContent
          this.answerNote = response.answerNote
        }
        this.isLoading = false
      })
    },
    saveForm () {
      this.isLoading = true
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/saveGeneralForm', {
        idChild: this.idChild,
        idForm: this.idForm,
        idGeneralForm: this.idGeneralForm,
        answerNote: this.answerNote,
        checkedAnswer: this.checkedAnswer
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response) {
          alert("Algemeen formulier is succesvol opgeslagen")
          this.$router.push('/childtrackingsystem/generalForm/' + this.idChild + '/' + this.idForm + '/' +  response.idGeneralForm)
        }
        this.isLoading = false
      })
    },
    printForm () {
      this.isLoading = true
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/downloadGeneralForm', {
        idChild: this.idChild,
        idForm: this.idForm,
        idGeneralForm: this.idGeneralForm
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response) {
          this.download(response.filename, response.fileContent)
        } else {
            this.isLoading = false
        }
      })
    },
    download(filename, fileContent) {
      var docUrl = document.createElement('a')
      docUrl.href = "data:application/octet-stream;base64," + fileContent
      docUrl.setAttribute('download', filename)
      document.body.appendChild(docUrl)
      docUrl.click()
      this.isLoading = false
    },
    goBack() {
      this.$router.push('/children/' + this.idChild + '/childtrackingsystem')
    }
  }
}
</script>
